import { Component, HostListener } from '@angular/core';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { TourService, TourStep } from './tour.service';

@Component({
  selector: 'app-tour-overlay',
  template: `
    <div *ngIf="active" class="tour-backdrop"></div>

    <div *ngIf="active && rect && step" class="tour-popover"
         [ngStyle]="positionStyle(rect, step.placement)">
      <div class="tour-arrow" [ngClass]="arrowClass(step.placement)"></div>
      <div class="tour-body">
        <div class="tour-header">
          <h4 class="tour-title">{{ step.title }}</h4>
          <p class="tour-step-count">Step {{ idx+1 }} of {{ total }}</p>
        </div>
        <p class="tour-content" [innerHTML]="step.content"></p>
        <div class="tour-actions">
          <button class="btn-trans" (click)="skip()">Skip Tour</button>
         <span class="spacer"></span>
        <button class="btn-trans" [disabled]="idx==0" (click)="prev()">Prev</button>
          <button class="btn-dark" (click)="next()">{{ idx===total-1 ? 'Done' : 'Next' }}</button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./tour-overlay.component.scss']
})
export class TourOverlayComponent {
  active = false;
  rect: DOMRect | null = null;
  step: TourStep | null = null;
  idx = 0; total = 0;

  constructor(private tour: TourService) {
    combineLatest([tour.active$, tour.step$, tour.rect$]).subscribe(([a, s, r]) => {
      this.active = a; this.step = s; this.rect = r;
      if (a && s) { this.idx = this.idxFromStep(s); this.total = this.totalSteps(); }
    });
  }
  @HostListener('window:resize') onResize() { this.tour.refreshPosition(); }
  @HostListener('window:scroll') onScroll() { this.tour.refreshPosition(); }

  next() { this.tour.next(); }
  prev() { this.tour.prev(); }
  skip() { this.tour.end(); }

  private idxFromStep(s: TourStep) { return (this as any).tour['index']; }
  private totalSteps() { return (this as any).tour['steps']?.length || 0; }

  positionStyle(rect: DOMRect, placement: TourStep['placement'] = 'auto') {
    // Simple placement solver; adjusts 16px gap from target
    const gap = 16;
    const popW = 420, popH = 140; // visual estimate; CSS handles actual width
    let top = rect.top, left = rect.left;

    if (placement === 'top')    { top = rect.top - popH - gap; left = rect.left + rect.width/2 - popW/2; }
    else if (placement === 'bottom'){ top = rect.top + rect.height + gap; left = rect.left + rect.width/2 - popW/2; }
    else if (placement === 'left')  { top = rect.top + rect.height/2 - popH/2; left = rect.left - popW - gap; }
    else if (placement === 'right') { top = rect.top + rect.height/2 - popH/2; left = rect.left + rect.width + gap; }
    else { // auto: prefer bottom, fallback inside viewport
      top = rect.top + rect.height + gap;
      left = Math.min(Math.max(16, rect.left + rect.width/2 - popW/2), window.scrollX + window.innerWidth - popW - 16);
    }
    return { top: `${Math.max(16, top)}px`, left: `${Math.max(16, left)}px`, width: '420px' };
  }
  arrowClass(p: TourStep['placement'] = 'auto') {
    return { top: p==='bottom', bottom: p==='top', left: p==='right', right: p==='left' };
  }
}
